export const sharedStyles = {
      position: 'fixed',
      overflow: 'hidden',
      backfaceVisibility: 'hidden',
      transformStyle: 'preserve-3d',
    //  transform: 'translate3d(0,0,0)'
    };
